import apiClient from './client.js';

const base = (wsId) => `/workspaces/${wsId}/analytics-p6`;

export const getPipelines = (wsId) =>
  apiClient.get(`${base(wsId)}/pipelines`);

export const getMembers = (wsId) =>
  apiClient.get(`${base(wsId)}/members`);

export const getKpis = (wsId, params = {}) =>
  apiClient.get(`${base(wsId)}/kpis`, { params });

export const getForecast = (wsId, params = {}) =>
  apiClient.get(`${base(wsId)}/forecast`, { params });

export const getFunnel = (wsId, params = {}) =>
  apiClient.get(`${base(wsId)}/funnel`, { params });

export const getActivities = (wsId, params = {}) =>
  apiClient.get(`${base(wsId)}/activities`, { params });

export const getTeamPerformance = (wsId, params = {}) =>
  apiClient.get(`${base(wsId)}/team`, { params });

export const getSnapshots = (wsId, params = {}) =>
  apiClient.get(`${base(wsId)}/snapshots`, { params });

export const captureSnapshot = (wsId) =>
  apiClient.post(`${base(wsId)}/snapshots/capture`);
